export default __webpack_public_path__ + "static/media/sender.55d529b7.jpg";